export const APP_CONFIG = {
  size: {
    width: 3120,
    height: 1560,
  },
  backHomeTime: 120000,
};
